<p-dialog
    appDialogoPadrao="pi pi-wallet"
    descricao="Modalidade de convênio de cobrança."
    [(visible)]="showDialog"
    (onShow)="onDialogShow()"
    (onHide)="hideDialog()"
    [breakpoints]="{ '1100px': '75vw', '500px': '90vw' }"
    [header]="convenio() ? 'Editar Tipo de Convênio' : 'Novo Tipo de Convênio'"
    styleClass="dialog-fullscreen-mobile"
    [maximizable]="true"
    [appendTo]="'body'"
>
    <ng-template #content>
        <div class="p-fluid" [formGroup]="convenioForm">
            <div class="flex flex-col gap-6">
                <!-- Campos de edit um abaixo do outro -->
                <div class="flex flex-col gap-4">
                    <div class="field">
                        <label for="sigla" class="font-semibold block mb-2">Sigla</label>
                        <input pInputText id="sigla" formControlName="sigla" placeholder="Ex: SIGCB" [class.ng-invalid]="isInvalid('sigla')" [class.ng-dirty]="isInvalid('sigla')" />
                        @if (isInvalid('sigla')) {
                            <p-message severity="error" size="small" variant="simple" class="mt-1">Sigla obrigatória</p-message>
                        }
                    </div>

                    <div class="field flex items-center gap-2 mt-2">
                        <p-toggleswitch formControlName="wsdlBoleto" inputId="wsdlBoleto"></p-toggleswitch>
                        <label for="wsdlBoleto" class="font-semibold cursor-pointer">WSDL Boleto</label>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #footer>
        <p-button label="Cancelar" icon="pi pi-times" text (click)="hideDialog()" />
        <p-button label="Salvar" icon="pi pi-check" [disabled]="convenioForm.invalid" (click)="salvar()" [appCan]="roleBancosEditar" />
    </ng-template>
</p-dialog>
